import { useCallback } from "react";
import { useNavigate, useParams } from "react-router";

import { getBreadcrumbsBackUrl } from "components/Breadcrumbs/helpers";
import NotFoundPage from "components/error/NotFoundPage";
import NoAccessPage from "components/error/NoAccessPage";
import PageLoading from "components/loading/PageLoading";
import FullScreenModal from "ds/components/FullScreenModal";
import useErrorHandle from "hooks/useErrorHandle";
import useCanTestTemplateDeployment from "shared/Templates/access/useCanTestTemplateDeployment";
import { TemplateDeploymentType } from "types/generated";

import useTemplateVersion from "../useTemplateVersion";
import DeployForm from "../Deploy/DeployForm";

const TestDeploy = () => {
  const { versionId, templateId } = useParams<{ versionId: string; templateId: string }>();
  const navigate = useNavigate();

  const { error, loading, data } = useTemplateVersion(templateId, versionId);
  const template = data?.template;

  const canTestDeployTemplate = useCanTestTemplateDeployment();

  useErrorHandle(error);

  const backUrl = getBreadcrumbsBackUrl(`/template/${templateId}/version/${versionId}`, "");

  const handleClose = useCallback(() => {
    navigate(backUrl);
  }, [navigate, backUrl]);

  if (!canTestDeployTemplate.result) {
    return <NoAccessPage />;
  }

  if (loading) {
    return <PageLoading />;
  }

  if (!template?.templateVersion || !templateId || !versionId) {
    return <NotFoundPage />;
  }

  return (
    <FullScreenModal title={`Deploy ${template.name} template`} onClose={handleClose}>
      <DeployForm
        version={template.templateVersion}
        templateName={template.name}
        templateId={templateId}
        deploymentType={TemplateDeploymentType.Test}
      />
    </FullScreenModal>
  );
};

export default TestDeploy;
